<template>
  <div id="app">
    <div class="container">
      <img :src="`${baseUrl}images/asprod-logo.png`" alt="Aplikacja Asprod Piekarnia – Cukiernia" class="app-logo">
      <h1 class="app-name">Aplikacja Asprod Piekarnia – Cukiernia</h1>
      
      <div class="store-buttons">
        <!-- Show only iOS button on iOS devices -->
        <a v-if="isIOS || !isMobile" 
           href="https://apps.apple.com/app/id6758014052"
           class="store-button ios-button">
          <img :src="`${baseUrl}images/app-store-badge.png`" alt="Download on App Store">
        </a>

        <!-- Show only Android button on Android devices -->
        <a v-if="isAndroid || !isMobile"
           href="https://play.google.com/store/apps/details?id=pl.asprod.app"
           class="store-button android-button">
          <img :src="`${baseUrl}images/google-play-badge.png`" alt="Get it on Google Play">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isIOS: false,
      isAndroid: false,
      isMobile: false,
      baseUrl: process.env.BASE_URL
    }
  },
  mounted() {
    // Detect device type on component mount
    const userAgent = navigator.userAgent.toLowerCase();
    this.isIOS = /iphone|ipad|ipod/.test(userAgent);
    this.isAndroid = /android/.test(userAgent);
    this.isMobile = this.isIOS || this.isAndroid;
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #FFFFFF; /* Changed to white */
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  padding: 20px;
  max-width: 600px;
  width: 100%;
  aspect-ratio: 1/1; /* Make container square */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app-logo {
  width: 250px; /* Reduced from 350px */
  height: 250px;
  max-width: 100%;
  height: auto;
  margin-bottom: 15px;
  border-radius: 70px; /* Adjusted for smaller size */
}

.app-name {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 25px;
  text-align: center;
  width: 100%;
  padding: 0 20px;
}

.store-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px; /* Reduced gap */
}

.store-button {
  display: block;
  width: 180px; /* Slightly smaller buttons */
  height: 54px;
}

.store-button img {
  width: 100%; /* Make image fill the button container */
  height: 100%; /* Make image fill the button container */
  object-fit: contain; /* Maintain aspect ratio */
}

@media (min-width: 768px) {
  .store-buttons {
    flex-direction: row;
    justify-content: center;
  }
}

.footer {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  color: #666666;
  font-size: 14px;
}

.footer:hover {
  opacity: 0.8;
}

.footer-logo {
  height: 20px;
  width: auto;
}
</style> 